const { fontWeight } = require("@mui/system");

const grey = {
	50: "#fbfbfb",
	100: "#f5f5f5",
	200: "#eeeeee",
	300: "#e0e0e0",
	400: "#bdbdbd",
	500: "#9e9e9e",
	600: "#757575",
	700: "#616161",
	800: "#3b3b3b",
	900: "#212121",
};

const themeConfig = {
	palette: {
		purple: {
			main: "#6f3178",
			light: "#6f3178",
			dark: "#6f3178",
			contrastText: "#ffffff",
		},
		deepPurple: {
			main: "#37236a",
			light: "#37236a",
			dark: "#37236a",
			contrastText: "#ffffff",
		},
		primary: {
			main: "#006699",
			light: "#006699",
			contrastText: "#ffffff",
			dark: "#003254",
		},
		secondary: {
			main: "#cc0066",
			light: "#cc0066",
			dark: "#cc0066",
			contrastText: "#ffffff",
		},
		closingHeadings: {
			main: "#cc0066",
			light: "#cc0066",
			dark: "#cc0066",
			contrastText: "#ffffff",
		},
		yellow: {
			main: "#ffdf88",
			light: "#ffdf88",
			dark: "#ffdf88",
			contrastText: "#ffffff",
		},
		orange: {
			main: "#ffa367",
			light: "#ffa367",
			dark: "#ffa367",
			contrastText: "#ffffff",
		},
		grey: {
			...grey,
			lighter: grey["100"],
			light: grey["200"],
			main: grey["200"],
			dark: grey["300"],
			darker: grey["400"],
			contrastText: grey["900"],
		},
		dark: {
			light: grey["700"],
			main: grey["800"],
			darker: grey["900"],
			contrastText: "#ffffff",
		},
		light: {
			main: grey["100"],
			dark: grey["200"],
			light: grey["50"],
			contrastText: grey["900"],
		},
		link: {
			main: "#006699",
			light: "#006699",
			dark: "#006699",
			contrastText: "#ffffff",
		},
		appBar: {
			public: {
				main: "#ffffff",
				light: "#ffffff",
				dark: "#ffffff",
				contrastText: "#006699",
			},
			private: {
				main: "#003254",
				light: "#003254",
				dark: "#003254",
				contrastText: "#ffffff",
			},
		},

		titleBar: {
			public: {
				main: "#cc0066",
				light: "#cc0066",
				dark: "#cc0066",
				contrastText: "#ffffff",
			},
			private: {
				main: "#cc0066",
				light: "#cc0066",
				dark: "#cc0066",
				contrastText: "#ffffff",
			},
		},
		footer: {
			main: "#006699",
			light: "#006699",
			dark: "#006699",
			contrastText: "#ffffff",
		},
    colophon: {
			main: "#006699",
			light: "#006699",
			dark: "#006699",
			contrastText: "#ffffff",
		},
	},
	typography: {
		fontFamily: [
			"Gudea",
			"-apple-system",
			"BlinkMacSystemFont",
			'"Segoe UI"',
			'"Helvetica Neue"',
			"Arial",
			"sans-serif",
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(","),
		fontWeight: 400,
		fontWeightBold: 700,
		lineHeight: 1.5,
		h1: {
			fontFamily: "Oswald",
			lineHeight: 1.3,
			fontWeight: 500,
			fontSize: "2.1rem",
		},
		h2: {
			fontFamily: "Oswald",
			lineHeight: 1.3,
			fontWeight: 500,
		},
		h3: {
			fontFamily: "Oswald",
		},
		h4: {
			fontFamily: "Oswald",
		},
		h5: {
			fontFamily: "Oswald",
		},
		h6: {
			fontFamily: "Oswald",
		},
		nav: {
			fontFamily: "Oswald",
		},
		brandTitle: {
			fontFamily: "Oswald",
		},
		titleBar: {
			fontFamily: "Oswald",
			lineHeight: 1.3,
			fontWeight: 500,
		},
		subtitle1: {
			fontStyle: "normal",
			fontWeight: 600,
			lineHeight: 1.5,
			letterSpacing: "-0.01562em",
			fontSize: "1.6rem",
		},
		overline: {
			fontStyle: "normal",
			lineHeight: 1.5,
			fontSize: "1.2rem",
			fontWeight: 400,
		},
	},
	cloverleaf: {
		googleFont: "Gudea:ital,wght@0,400;0,700;1,400&family=Oswald:wght@500",
		navbarAlign: "right",
		closingHeadingsStyled: true,
		closingHeadingsFlatColor: true,
		brand: {
			size: 124,
		},
		navbar: {
			align: "right",
		},
		footer: {
			disableBrand: true,
			socialLinksProps: {
				size: "1.5rem",
				spacing: "0rem",
			},
		},
		tags: {
			position: "bottom",
		},
		css: `
      #___gatsby .call-to-action {
        padding: 3rem 0rem;
      }
      .desktop-nav {
        position: relative;
      }
      .desktop-nav:before {
        right: 0;
        width: 150%;
        top: -2px;
        height: 1px;
        display: block;
        position: absolute;
        content: " ";
        background-image: linear-gradient(
          90deg,
          hsla(0, 0%, 100%, 0) 28%,
          rgba(33, 63, 101, 0.21)
        );
      }
      footer .footer + .MuiBox-root .MuiContainer-root > .MuiBox-root {
        position: relative;
      }
      footer .footer + .MuiBox-root .MuiContainer-root > .MuiBox-root:before {
          top: -1rem;
          left: 0;
          width: 100%;
          height: 1px;
          display: block;
          opacity: 0.2;
          content: " ";
          position: absolute;
          background-color: white;
    }
	div.text li a {
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}
    `,
	},
};
module.exports = themeConfig;
